import React, { useEffect, useState } from "react";
import { GetProducts } from "../../../services/product";
import { GetSingleBundle, UpdateSingleBundle } from "../../../services/bundle";
import { useParams } from "react-router-dom";
import useProductsStore from "../../../store/product";
import BundleForm from "../../../forms/Bundles/index";
import { GetCategories } from "../../../services/category";
import { GetBoxes } from "../../../services/box";

const UpdateBundle = () => {
  const { id } = useParams();
  const [bundle, setBundle] = useState(null);
  const [categories, setCategories] = useState([]);
  const [boxes, setBoxes] = useState([]);
  const { setProducts } = useProductsStore();
  const [currentProductPage, setCurrentPage] = useState(1);
  const [isSearching, setIsSearching] = useState(false);
  const handleSubmit = async (bundle) => {
    return UpdateSingleBundle({ payload: bundle, id });
  };
  const fetchProducts = async (searchTerm = "") => {
    setIsSearching(true);
    const { data } = await GetProducts(searchTerm, currentProductPage);
    if (data?.result) {
      setProducts(data.result);
    }
    setIsSearching(false);
  };
  const fetchBundle = async () => {
    const { data } = await GetSingleBundle(id);
    if (data.result) {
      setBundle(data.result);
    }
  };
  const fetchCategories = async () => {
    const { data } = await GetCategories();
    if (data.result) {
      setCategories(data.result);
    }
  };

  useEffect(() => {
    fetchBundle();
    fetchCategories();
  }, [id]);
  useEffect(() => {
    fetchProducts();
  }, [currentProductPage]);

  const fetchBoxes = async () => {
    const { data } = await GetBoxes();
    if (data.result) {
      setBoxes(data.result);
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchBoxes();
  }, []);

  return (
    <>
      {bundle ? (
        <BundleForm
          isSearching={isSearching}
          searchProduct={fetchProducts}
          onSubmit={handleSubmit}
          key={"create-bundle"}
          bundle={bundle}
          categories={categories}
          boxes={boxes}
          form={""}
          productPage={currentProductPage}
          setProductPage={setCurrentPage}
          heading={"Update bundle"}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default UpdateBundle;
